import { useEffect, useState } from 'react';
import { Api } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';

const AboutPage = () => {
  const { t } = useLanguage();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const loadLabels = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await Api.fetchLabels();
        const payload = response?.data?.data || response?.data || {};
        if (mounted) {
          setContent(payload.aboutUs || '');
        }
      } catch (err) {
        if (mounted) {
          setError(err?.message || t('about.error'));
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadLabels();
    return () => {
      mounted = false;
    };
  }, [t]);

  const renderContent = () => {
    if (loading) {
      return <p className="info-page__state">{t('about.loading')}</p>;
    }
    if (error) {
      return (
        <p className="info-page__state info-page__state--error">{error}</p>
      );
    }
    if (!content) {
      return <p className="info-page__state">{t('about.empty')}</p>;
    }
    return (
      <div
        className="info-page__copy"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  };

  return (
    <section className="info-page">
      <div className="info-page__hero">
        <p className="eyebrow info-page__eyebrow">{t('about.eyebrow')}</p>
        <h1>{t('about.heading')}</h1>
        <p>{t('about.subtitle')}</p>
      </div>
      <div className="info-page__content">{renderContent()}</div>
    </section>
  );
};

export default AboutPage;
